import { ReactNode, useEffect } from 'react';
import logPurchasePlatformRedirect from '@alltrails/amplitude/events/logPurchasePlatformRedirect';
import SubscriptionProvider from '@alltrails/amplitude/enums/SubscriptionProvider';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import HeadToTheAppMobileDialog from './HeadToTheAppMobileDialog';
import HeadToTheAppDesktopDialog from './HeadToTheAppDesktopDialog';

type Props = {
  href?: string;
  onCloseRequest: () => void;
  provider: 'apple' | 'google';
  text: ReactNode;
};

const originalProvider: Record<Props['provider'], SubscriptionProvider> = {
  apple: 'apple',
  google: 'google'
};

// https://www.figma.com/design/PtYSSpohQ9rL7ZWCcdsYJK/2025-Upsell-System?node-id=7373-65685&t=R6dqqUgBb8OhoksN-0
export default function HeadToTheAppDialogBase({ href, onCloseRequest, provider, text }: Props) {
  const isMobile = useIsMobileSizedScreen();

  useEffect(() => {
    logPurchasePlatformRedirect({ original_provider: originalProvider[provider] });
  }, [provider]);

  if (isMobile) {
    return <HeadToTheAppMobileDialog href={href} onCloseRequest={onCloseRequest} provider={provider} text={text} />;
  }

  return <HeadToTheAppDesktopDialog href={href} onCloseRequest={onCloseRequest} provider={provider} text={text} />;
}
